import { render, staticRenderFns } from "./ProcessChargesOrders.vue?vue&type=template&id=1a9f76e0&scoped=true&"
import script from "./ProcessChargesOrders.vue?vue&type=script&lang=js&"
export * from "./ProcessChargesOrders.vue?vue&type=script&lang=js&"
import style0 from "./ProcessChargesOrders.vue?vue&type=style&index=0&id=1a9f76e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9f76e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9f76e0')) {
      api.createRecord('1a9f76e0', component.options)
    } else {
      api.reload('1a9f76e0', component.options)
    }
    module.hot.accept("./ProcessChargesOrders.vue?vue&type=template&id=1a9f76e0&scoped=true&", function () {
      api.rerender('1a9f76e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/ProcessChargesOrders.vue"
export default component.exports